// Lightweight client-side A/B test bucketing.
// Deterministic per-browser via localStorage. Variant is attached to every funnel
// event under props.ab so server-side analysis can compute uplift.

export type Variant = "A" | "B";

const STORAGE_KEY = "peoples:ab:v1";

type Assignments = Record<string, Variant>;

function read(): Assignments {
  if (typeof window === "undefined") return {};
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") as Assignments; }
  catch { return {}; }
}

function write(a: Assignments) {
  if (typeof window === "undefined") return;
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(a)); } catch { /* noop */ }
}

/** Get or assign a 50/50 variant for the given experiment key. SSR-safe (returns "A"). */
export function getVariant(experiment: string): Variant {
  if (typeof window === "undefined") return "A";
  const all = read();
  if (all[experiment] === "A" || all[experiment] === "B") return all[experiment];
  const v: Variant = Math.random() < 0.5 ? "A" : "B";
  all[experiment] = v;
  write(all);
  return v;
}

/** All assignments — attached to every tracked event for offline analysis. */
export function getAllAssignments(): Assignments {
  return read();
}

export const EXPERIMENTS = {
  SAFETY_MODAL_COPY: "safety_modal_copy_v1",
} as const;
